// `{ [stepId]: 'added' | 'changed' }` from a step diff, for tagging the rows of the steps it names. Removed steps have
// no row on the newer side, so the views that show them list them separately.
const buildStepChangeMarks = (changes) => {
  const marks = {};

  for (const step of changes?.added || []) {
    marks[step.stepId] = 'added';
  }

  for (const { step } of changes?.changed || []) {
    marks[step.stepId] = 'changed';
  }

  return marks;
};

export default buildStepChangeMarks;
